

export function createXLSheetdata(attritionList) {
    attritionList.find((ticketDetails, index) => {                


                delete attritionList[index]['id']

                delete attritionList[index]['employee_id']
                delete attritionList[index]['status_reason']
                delete attritionList[index]['kitchen']



                attritionList[index].EmployeeCode=attritionList[index].employee_code                
                delete attritionList[index]['employee_code']

                attritionList[index].EmployeeName=attritionList[index].employee_name
                delete attritionList[index]['employee_name']

                attritionList[index].EmployeeMobile=attritionList[index].employee_mobile
                delete attritionList[index]['employee_mobile']


                attritionList[index].Designation=attritionList[index].designation
                delete attritionList[index]['designation']


                attritionList[index].Status=attritionList[index].status
                delete attritionList[index]['status']

                attritionList[index].ReasonName=attritionList[index].reason_name
                delete attritionList[index]['reason_name']

                attritionList[index].ReasonRemarks=attritionList[index].status_remarks
                delete attritionList[index]['status_remarks']

                attritionList[index].KitchenName=attritionList[index].kitchen_work_location_name
                delete attritionList[index]['kitchen_work_location_name']


                attritionList[index].KitchenCode=attritionList[index].kitchen_work_location_code
                delete attritionList[index]['kitchen_work_location_code']

                attritionList[index].RespondedBy=attritionList[index].approver
                delete attritionList[index]['approver']


                attritionList[index].CreatedOn=attritionList[index].created_on
                delete attritionList[index]['created_on']
                

                attritionList[index].ModifiedOn=attritionList[index].modified_on
                delete attritionList[index]['modified_on']

                delete attritionList[index]['gender']
                delete attritionList[index]['dob']
                delete attritionList[index]['doj']
                delete attritionList[index]['email']


                
            
                return false
            })   
            return attritionList
}




export function createXLSheetdataForAcademy(attritionList) {
    attritionList.find((ticketDetails, index) => {                


                attritionList[index].EmployeeCode=attritionList[index].employee_code                
                delete attritionList[index]['employee_code']

                attritionList[index].FullName=attritionList[index].employee_name
                attritionList[index].UserName=attritionList[index].employee_name
                delete attritionList[index]['employee_name']

                attritionList[index].DateOfBirth=attritionList[index].dob
                delete attritionList[index]['dob']

                attritionList[index].Gender=attritionList[index].gender
                delete attritionList[index]['gender']

                attritionList[index].Email=attritionList[index].email
                delete attritionList[index]['email']

                attritionList[index].ContactNumber=attritionList[index].employee_mobile

                delete attritionList[index]['employee_mobile']

                attritionList[index].Designation=attritionList[index].designation
                delete attritionList[index]['designation']

                attritionList[index].JoiningDate=attritionList[index].doj
                delete attritionList[index]['doj']

                attritionList[index].StoreCode =attritionList[index].kitchen_code
                delete attritionList[index]['kitchen_code']
                
            
                return false
            })   
            return attritionList
}





// WEBPACK FOOTER //
// ./src/modules/New Joinee/services/helpers.js